const pascalCaseReverse = function(text: string) {
  return text
  .replace(/([a-z])([A-Z])/g, '$1 $2')
  .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
  .replace(/^./, function(str: any){ return str.toUpperCase() })
}

export default pascalCaseReverse
